import { AutocompleteWebsiteItem, EmptyState } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import { WEBSITES_RESPONSE_LENGTH } from "app/pages/activation/components/HomeSearch/config";
import { createWebsiteUrl } from "app/pages/activation/components/HomeSearch/helpers/createWebsiteUrl";
import { filterBlockedSites } from "app/pages/activation/components/HomeSearch/helpers/filterBlockedSites";
import { redirectToUrl } from "app/pages/activation/components/HomeSearch/helpers/redirectToUrl";
import { NO_RESULTS } from "app/pages/activation/components/HomeSearch/texts";
import type { OnSearchItemClick } from "app/pages/activation/components/HomeSearch/types";
import { getWebsiteResults } from "app/services/solutions2Services/HomepageDataFetchers/NewModulesHomepageDataFetcher";

export const generateWebsiteResponse = async (query: string, onClick?: OnSearchItemClick) => {
    const websiteResults = await getWebsiteResults(query, WEBSITES_RESPONSE_LENGTH);

    const filteredResults = filterBlockedSites(websiteResults);

    if (!filteredResults.length) {
        return <EmptyState title={translate(NO_RESULTS)} />;
    }

    return filteredResults.map(({ name, image }) => {
        const url = createWebsiteUrl(name);

        const onItemClick = () => {
            onClick?.(name, "search_result");

            redirectToUrl(url);
        };

        return (
            <AutocompleteWebsiteItem
                mainSite={{ domain: name, iconUrl: image }}
                onItemClick={onItemClick}
            />
        );
    });
};
